export default "__VITE_ASSET__DGPHv0q___"